import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { forwardRef } from 'react';
import { styled, StyleSheet, useToken, text, padding, border, margin, icon } from '@rexlabs/styling';
import ActionMenuSvg from '@rexlabs/icons/action-menu-vertical.svg';
var buttonStyles = StyleSheet({
  container: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: function height(_ref) {
      var token = _ref.token;
      return token('actionMenu.button.height', '2.5rem');
    },
    width: function width(_ref2) {
      var token = _ref2.token;
      return token('actionMenu.button.width', '2.5rem');
    },
    background: function background(_ref3) {
      var token = _ref3.token;
      return token('actionMenu.button.background.color', token('color.container.interactive.idle'));
    }
  }, text.styles({
    target: 'actionMenu.button',
    fallback: 'normal.default'
  })), margin.styles({
    target: 'actionMenu.button'
  })), padding.styles({
    target: 'actionMenu.button',
    all: 'none'
  })), border.styles({
    target: 'actionMenu.button',
    all: {
      width: 'none',
      radius: 'small'
    }
  })), {}, {
    '& > svg': _objectSpread({}, icon.styles({
      target: 'actionMenu.button',
      size: 's'
    })),
    '&:hover': _objectSpread(_objectSpread({
      background: function background(_ref4) {
        var token = _ref4.token;
        return token('actionMenu.button.hover.background.color', token('color.container.interactive.hover'));
      }
    }, text.styles({
      target: 'actionMenu.button.hover',
      fallback: 'normal.default'
    })), border.styles({
      target: 'actionMenu.button.hover'
    })),
    '&:active': _objectSpread(_objectSpread(_objectSpread({}, text.styles({
      target: 'actionMenu.button.active',
      fallback: 'normal.default'
    })), border.styles({
      target: 'actionMenu.button.active'
    })), {}, {
      background: function background(_ref5) {
        var token = _ref5.token;
        return token('actionMenu.button.active.background.color');
      }
    })
  })
});

function ActionMenuButton(_ref6) {
  var isOpen = _ref6.isOpen,
      s = _ref6.styles,
      IconProp = _ref6.Icon,
      forwardedRef = _ref6.forwardedRef,
      props = _objectWithoutProperties(_ref6, ["isOpen", "styles", "Icon", "forwardedRef"]);

  var token = useToken();
  var Icon = IconProp !== null && IconProp !== void 0 ? IconProp : token('actionMenu.button.icon.svg', ActionMenuSvg);
  return /*#__PURE__*/React.createElement("button", _extends({
    ref: forwardedRef
  }, props, s.with('container')(props)), /*#__PURE__*/React.createElement(Icon, null));
}

var StyledButton = styled(buttonStyles)(ActionMenuButton); // eslint-disable-next-line

export default /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(StyledButton, _extends({}, props, {
    forwardedRef: ref
  }));
});